import { memo } from 'react';
import Modal from 'shared/Modal';
import { Box, Button, Flex, Text } from 'theme-ui';
import { useTranslator } from '@picsart/rc/services/localization';

type TemplateConfirmModalProps = {
  opened: boolean;
  closeHandler: () => void;
  applyHandler: () => void;
};

export const TemplateConfirmModal = memo(
  ({ opened, closeHandler, applyHandler }: TemplateConfirmModalProps) => {
    const translator = useTranslator();

    return (
      <Modal
        color="transparent"
        opened={opened}
        closeHandler={closeHandler}
        title={translator('Are_you_sure?')}
      >
        <Box sx={{ maxWidth: 352 }}>
          <Flex sx={{ flexDirection: 'column', alignItems: 'center' }}>
            <Text variant="body" sx={{ textAlign: 'left', fontSize: '16px' }}>
              {translator('Your_changes_won’t_be_saved._Do_you_still_want_to_change_the_template?')}
            </Text>
            <Flex sx={{ alignSelf: 'flex-end' }}>
              <Button
                variant="invertedOutlined"
                onClick={applyHandler}
                sx={{ px: 7, py: 4, mt: 6, mr: 3, fontSize: 2 }}
              >
                {translator('Yes')}
              </Button>
              <Button
                variant="primary"
                onClick={closeHandler}
                sx={{
                  px: 7,
                  py: 4,
                  mt: 6,
                  borderStyle: 'solid',
                  borderWidth: 1,
                  borderColor: 'primary',
                  fontSize: 2
                }}
              >
                {translator('No')}
              </Button>
            </Flex>
          </Flex>
        </Box>
      </Modal>
    );
  }
);
